import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.188 2.667h-2V2a.667.667 0 0 0-.667-.667H4.854A.667.667 0 0 0 4.188 2v.667h-2a.667.667 0 0 0-.667.666v2A2.667 2.667 0 0 0 4.188 8h1.026a4 4 0 0 0 2.307 1.273v1.394h-.667a2 2 0 0 0-2 2V14a.666.666 0 0 0 .667.667h5.333a.666.666 0 0 0 .667-.667v-1.333a2 2 0 0 0-2-2h-.667V9.273A4 4 0 0 0 11.161 8h1.027a2.667 2.667 0 0 0 2.666-2.667v-2a.666.666 0 0 0-.666-.666m-10 4a1.333 1.333 0 0 1-1.334-1.334V4h1.334v1.333a4 4 0 0 0 .233 1.334zM9.52 12a.667.667 0 0 1 .666.667v.666h-4v-.666A.667.667 0 0 1 6.855 12zm1.333-6.667a2.667 2.667 0 1 1-5.333 0V2.667h5.333zm2.667 0a1.334 1.334 0 0 1-1.334 1.334h-.233c.153-.428.232-.88.233-1.334V4h1.334z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })